import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Header/Header";
import SectionOne from "./Section1/SectionOne";
import SectionTwo from "./Section2/SectionTwo";
import SectionThree from "./Section3/SectionThree";
import SectionFour from "./Section4/SectionFour";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";

const LandingMain = () => {
  return (
    <Router>
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&family=Satisfy&display=swap');`}
      </style>

      <Header />

      <Routes>
        <Route path="/" element={
          <>
            <SectionOne />
            <SectionTwo />
            <SectionThree />
            <SectionFour />
          </>
        }/>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
};

export default LandingMain;
